const sync = {
	name: 'Aktualisierungen',
	fields: {
		started_at: 'Gestartet am',
		ended_at: 'Beendet am',
		total_count: 'Aktualisierungen',
	},
}

export default sync
